<template>
    <tbody :class="style['mds-data-table__body']">
        <slot>
            <mds-data-table-row
                v-for="(row, index) in rowData"
                :key="index"
                ref="row"
                :row-index="index"
                :header-configs="headerConfigs"
                :row-data="row"
                :id="row.id"
                @mds-data-table-row-selection-change="emitRowSelected(arguments)"
                @mouseover.native="onMouseenterRow({ index, arguments })"
                @mouseleave.native="onMouseleaveRow({ index, arguments })"
                @click.native="onMouseClickRow({ index, arguments })"
            >
                <template v-slot:body-cell="cellData">
                    <slot name="body-cell" v-bind="cellData" />
                </template>
            </mds-data-table-row>
        </slot>
    </tbody>
</template>

<script>
    import MdsDataTableRow from './data-table-row.vue';

    export default {
        name: 'MdsDataTableBody',
        components: {
            MdsDataTableRow,
        },
        props: {
            align: {
                type: String,
                default: 'left',
                validator(value) {
                    return ['left', 'right'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `left`, `right`.',
                    description: 'Sets the column content alignment.',
                },
            },
            rowData: {
                type: Array,
                default: () => [],
                docs: {
                    validation: '—',
                    description: 'Sets the data items to display in row cells.',
                },
            },
            headerConfigs: {
                type: Array,
                default: () => [],
                docs: {
                    validation: '—',
                    description:
                        'Set of objects that describe each header column. See the header cell props for a definition of all properties.',
                },
            },
            rowsSelected: {
                type: Array,
                default: () => [],
                docs: {
                    validation: '—',
                    description: 'Sets rows selected in `multiselection` table.',
                },
            },
        },
        provide() {
            const bodyVariation = {};
            Object.defineProperty(bodyVariation, 'multiSelect', {
                enumerable: true,
                get: () => this.multiSelect,
            });
            Object.defineProperty(bodyVariation, 'rowNumber', {
                enumerable: true,
                get: () => this.rowNumber,
            });
            Object.defineProperty(bodyVariation, 'responsive', {
                enumerable: true,
                get: () => this.responsive,
            });
            Object.defineProperty(bodyVariation, 'style', {
                enumerable: true,
                get: () => this.style,
            });
            return { bodyVariation };
        },
        inject: ['parentVariation'],
        computed: {
            multiSelect() {
                return this.parentVariation && this.parentVariation.multiSelect;
            },
            rowNumber() {
                return this.parentVariation && this.parentVariation.rowNumber;
            },
            responsive() {
                return this.parentVariation && this.parentVariation.responsive;
            },
        },
        data() {
            return {
                dataChecked: false,
                dataSelectedRows: this.rowsSelected,
                pageRowsSelected: 1,
                currentPage: 1,
                style: this.parentVariation.style,
            };
        },
        methods: {
            updateBodySelectedRows(ev) {
                const checked = ev.checked;
                const rowID = ev.id;
                if (checked && !this.dataSelectedRows.includes(rowID)) {
                    this.dataSelectedRows.push(rowID);
                }
                if (!checked && this.dataSelectedRows.includes(rowID)) {
                    this.dataSelectedRows.splice(this.dataSelectedRows.indexOf(rowID), 1);
                }
            },
            emitRowSelected(ev) {
                this.updateBodySelectedRows(ev[0]);
                this.$emit('mds-data-table-row-selection-change', ev[0]);
            },
            onMouseClickRow(ev) {
                const obj = {
                    rowIndex: ev.index,
                };
                const event = ev.arguments[0];
                this.$emit('mds-data-table-row-click', obj, event);
            },
            onMouseenterRow(ev) {
                const obj = {
                    hover: true,
                    rowIndex: ev.index,
                };
                const event = ev.arguments[0];
                this.$emit('mds-data-table-row-hover-change', obj, event);
            },
            onMouseleaveRow(ev) {
                const obj = {
                    hover: false,
                    rowIndex: ev.index,
                };
                const event = ev.arguments[0];
                this.$emit('mds-data-table-row-hover-change', obj, event);
            },
        },
    };
</script>
